'use strict';

const libPictView = require('pict-view');

/**
 * EntityDestinationsConfig view: the shell for the #/EntityDestinations screen ("Where Records Open").
 * Paints the header and a single #EDC-Detail mount; the EntityDestinationsConfig provider renders the rest.
 */
class EntityDestinationsConfig extends libPictView
{
	get provider()
	{
		return this.pict.providers.EntityDestinationsConfig;
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
			{
				tmpProvider.loadAsync();
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = EntityDestinationsConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'EntityDestinationsConfig',
	DefaultRenderable: 'EntityDestinationsConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.edc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.edc-head { margin: 0 0 1rem; }
		.edc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.edc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.edc-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:52rem; }
		.edc-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.edc-field { margin:0 0 0.9rem; }
		.edc-field-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
		.edc-select { font-size:0.9rem; padding:0.42rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); min-width:20rem; max-width:100%; }
		.edc-narrow { min-width:10rem; }
		.edc-input { font-size:0.88rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; width:100%; max-width:28rem; }
		.edc-route { max-width:100%; margin-top:0.4rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.edc-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.edc-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0.2rem 0 0.8rem; flex-wrap:wrap; }
		.edc-tab { font-size:0.88rem; font-weight:600; padding:0.45rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.edc-tab.is-active { color:var(--theme-color-brand-primary,#5650e6); border-bottom-color:var(--theme-color-brand-primary,#5650e6); }
		.edc-help, .edc-hint { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.8rem; }
		.edc-hint code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.edc-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
		.edc-rules { display:flex; flex-direction:column; gap:0.5rem; margin:0 0 0.9rem; }
		.edc-rule { display:flex; gap:0.75rem; align-items:center; padding:0.6rem 0.75rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:9px; background:var(--theme-color-background-panel,#fff); }
		.edc-rule.is-off { opacity:0.6; }
		.edc-rule-order { display:flex; flex-direction:column; gap:0.2rem; }
		.edc-mv { width:1.7rem; height:1.4rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:transparent; color:var(--theme-color-text-muted,#8894a4); cursor:pointer; font-size:0.7rem; }
		.edc-mv[disabled] { opacity:0.35; cursor:default; }
		.edc-rule-body { flex:1 1 auto; min-width:0; }
		.edc-rule-label { font-weight:650; color:var(--theme-color-text-primary,#1f2733); }
		.edc-rule-sentence { font-size:0.84rem; color:var(--theme-color-text-secondary,#45505f); }
		.edc-off { font-size:0.7rem; font-weight:700; text-transform:uppercase; color:var(--theme-color-text-muted,#8894a4); margin-left:0.3rem; }
		.edc-rule-actions { display:flex; gap:0.3rem; flex-wrap:wrap; justify-content:flex-end; }
		.edc-btn { font-size:0.82rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.edc-btn.is-danger:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.edc-chips { display:flex; flex-wrap:wrap; gap:0.35rem 0.8rem; }
		.edc-rule.is-platform { background:var(--theme-color-background-secondary,#f7f9fb); border-style:dashed; }
		.edc-badge { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.05rem 0.45rem; margin-left:0.35rem; }
		.edc-picker { display:flex; flex-direction:column; gap:0.4rem; max-width:28rem; }
		.edc-tags { display:flex; flex-wrap:wrap; gap:0.3rem; }
		.edc-tag { display:inline-flex; align-items:center; gap:0.25rem; font-size:0.82rem; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-selected,#eef0fe);
			border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.1rem 0.2rem 0.1rem 0.6rem; }
		.edc-tag-x { border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.95rem; line-height:1; padding:0 0.3rem; }
		.edc-suggest { display:flex; flex-direction:column; align-items:stretch; }
		.edc-suggest:empty { display:none; }
		.edc-suggestion { text-align:left; font-size:0.85rem; padding:0.35rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-top:none; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.edc-suggestion:first-child { border-top:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px 6px 0 0; }
		.edc-suggestion:hover, .edc-suggestion:focus { background:var(--theme-color-background-selected,#f5f5fe); }
		.edc-chip { font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); display:inline-flex; gap:0.3rem; align-items:center; }
		.edc-editor { border:1px solid var(--theme-color-brand-primary,#5650e6); border-radius:9px; padding:0.9rem 1rem; margin:0 0 0.9rem; background:var(--theme-color-background-selected,#f5f5fe); }
		.edc-editor-actions { display:flex; gap:0.5rem; align-items:center; }
		.edc-savebar { margin:0.9rem 0 1.2rem; display:flex; gap:0.8rem; align-items:center; }
		.edc-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.edc-save[disabled] { opacity:0.6; cursor:default; }
		.edc-unsaved { font-size:0.82rem; color:var(--theme-color-status-warning,#b7791f); }
		.edc-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.edc-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
		.edc-preview { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:0.9rem; }
		.edc-preview-result { font-size:0.86rem; background:var(--theme-color-background-tertiary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; color:var(--theme-color-text-primary,#1f2733); }
		.edc-preview-result code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.8rem; word-break:break-all; }
		.edc-explain { margin-top:0.4rem; font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); }
		@media (max-width: 640px)
		{
			.edc-wrap { padding: 1rem; }
			.edc-rule { flex-wrap:wrap; }
			.edc-select { min-width:0; width:100%; }
		}
	`,
	Templates:
	[
		{
			Hash: 'EntityDestinationsConfig-Wrap',
			Template: /*html*/`
				<div class="edc-wrap">
					<div class="edc-head">
						<h1 class="edc-title">Where Records Open</h1>
						<p class="edc-subtitle">Choose where a scanned QR label or an emailed link takes each person. With no rules, labels and links open where they always have.</p>
					</div>
					<div id="EDC-Detail" class="edc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'EntityDestinationsConfigWrap',
			TemplateHash: 'EntityDestinationsConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
